/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Card, CardContent, Slider } from "@repo/ui";
import React from "react";
import { Link } from "react-router-dom";

export default function ProgressBarChart({
  title,
  value,
  totalString,
  valueString,
  count,
  disabledNavigation,
  filters,
}: {
  title: string;
  status: string;
  value: number;
  valueString: string;
  totalString: string;
  count?: number;
  disabledNavigation?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters?: any;
}) {
  const nf = Intl.NumberFormat();
  const getRedirectURL = () => {
    let redirectString = `title=${title}&status=opentotal`;
    if (filters?.assignmentGroup?.id) {
      redirectString = `${redirectString}&assignmentGroup=${filters.assignmentGroup.id}`;
    }
    if (filters?.account?.id) {
      redirectString = `${redirectString}&accountId=${filters.account.id}`;
    }
    if (filters?.region?.id) {
      redirectString = `${redirectString}&region=${filters.region.id}`;
    }
    if (filters?.date?.id) {
      redirectString = `${redirectString}&period=${filters.date.id}`;
    }
    if (filters?.loggedToday) {
      redirectString = `${redirectString}&loggedToday=Yes`;
    }
    if (filters?.carriedOverCalls) {
      redirectString = `${redirectString}&carriedOverCalls=Yes`;
    }
    if (filters?.vaultAccessRequired) {
      redirectString = `${redirectString}&vaultAccessRequired=Yes`;
    }
    return redirectString;
  };
  return (
    <Card>
      <Link
        to={disabledNavigation ? "" : `/dashboard-detail?${getRedirectURL()}`}
      >
        <CardContent className="p-4">
          <h3 className="font-semibold text-lg">
            {title}({nf.format(count || 0)})
          </h3>
          <div className="grid grid-cols-[max-content_max-content] justify-between mt-3 gap-3">
            <span>{valueString}</span>
            <span>{totalString}</span>
            <Slider
              className="col-span-2"
              defaultValue={[1]}
              value={[value]}
              max={100}
              step={1}
              disabled
            />
          </div>
        </CardContent>
      </Link>
    </Card>
  );
}
